import {z} from 'zod'

import {FormValidationInput} from '../../types'

import {UnloadingMethodsConfiguration, UnloadingMethodForm} from './types'

export const validateUnloadingMethod = (
  data: UnloadingMethodForm,
  ctx: z.RefinementCtx,
  {
    configuration: {unloadingMethods: unloadingMethodConfiguration}
  }: FormValidationInput<UnloadingMethodsConfiguration>
) => {
  // If unloading method is not enabled, skip validation
  if (!unloadingMethodConfiguration.isEnabled) {
    return
  }

  const unloadingMethod = data.unloadingMethod

  // Check if user has either selected an unloading method OR configured a pump
  const hasUnloadingMethodCode = unloadingMethod?.unloadingMethodCode
  const hasPumpConfiguration = unloadingMethod?.pump

  // User must choose either pump service OR select an unloading method
  if (!hasUnloadingMethodCode && !hasPumpConfiguration) {
    ctx.addIssue({
      code: z.ZodIssueCode.custom,
      path: ['unloadingMethod'],
      message: 'Please select an unloading method or configure pump service'
    })
    return
  }

  // If pump configuration is provided, validate it has the required fields
  if (hasPumpConfiguration && unloadingMethod?.pump) {
    const pumpConfig = unloadingMethod.pump

    if (!pumpConfig.pumpNumber) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ['unloadingMethod', 'pumpConfiguration', 'pumpNumber'],
        message: 'Pump code is required'
      })
    }

    if (!pumpConfig.pumpSettings.discharge) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ['unloadingMethod', 'pumpConfiguration', 'discharge'],
        message: 'Discharge method is required'
      })
    }

    // If discharge is 'hose', hose length is required
    if (
      pumpConfig.pumpSettings.discharge.method === 'hose' &&
      pumpConfig.pumpSettings.discharge.hoseLength === undefined
    ) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ['unloadingMethod', 'pumpConfiguration', 'hoseLength'],
        message: 'Hose length is required when discharge method is hose'
      })
    }
  }
}
